import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ReportService } from '../report.service';
import { SharedService } from '../../../shared/shared.service';
import { Logger } from 'angular2-logger/core';

@Component({
  selector: 'app-report-bar',
  templateUrl: './report-bar.component.html',
  styleUrls: ['./report-bar.component.scss']
})
export class ReportBarComponent implements OnInit {
  @Input() public info: any;
  public type_report: string;
  public state_report: Array<number>;
  public date_start_report: string;
  public date_end_report: string;
  public date: string;
  @ViewChild('chart') myButton: ElementRef;

  constructor(
    private _reportService: ReportService,
    private _sharedService: SharedService,
    private renderer: Renderer2,
    private logger: Logger) {
  }

  customizeSeries(valueFromNameField: number) {
      return valueFromNameField === 2009 ?
          { type: 'line', label: { visible: true }, color: '#ff3f7a' } : {};
  }

  ngOnInit() {
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  test_click() {

  }

  test() {
    let val = (<HTMLScriptElement[]><any>document.querySelectorAll('dx-export-menu-list-item'));
    console.log('Etiqueta');
    console.log(val);
    let val2 = (<HTMLScriptElement[]><any>document.getElementsByClassName('dx-export-menu-list-item').item(1));
    console.log('Etiqueta2');
    console.log(val2);
    /*Array.prototype.filter.call(val2, function(val2){
      console.log(val2);
      //return testElement.nodeName === 'DIV';
  });
    /*for (let i = 0; i < val2.length; i++) {
      console.log(val2[i].innerHTML);
  }*/
    let val3 = (<HTMLScriptElement[]><any>document.getElementsByClassName('dx-export-menu-button'));
    console.log(val3);
    for (let i = 0; i < val3.length; i++) {
      val3[i].addEventListener('click', () => { alert('Probando'); });
  }
    //this.renderer.selectRootElement(val3).click();
    let val4 = (<HTMLScriptElement[]><any>document.getElementsByTagName('text'))[0];
  console.log('Etiqueta3');
  console.log(val4);
  /*for (let i = 0; i < val4.length; i++) {
    console.log(val4[i].innerHTML);
}
  /*const val5: HTMLElement = document.getElementsByTagName('text');
  alert(val5);*/
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/report/report-bar/report-bar.component.ts